import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IAddress } from 'src/app/models/IAddress';
import { ToastrService } from 'ngx-toastr';
import { Guid } from 'guid-typescript';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IAttributes } from 'src/app/models/IAttributes';
import { ICityDetails } from 'src/app/models/ICityDetails';
import { element } from 'protractor';
import { ProfessionalPayerComponent } from '../activepayers/professional-payer/professional-payer.component';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { InsuranceCarriers } from 'src/app/models/InsuranceCarriers';
import { IInsuranceCarriers } from 'src/app/models/IInsuranceCarriers';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { Defaults } from 'src/app/Utilities/defaults';
@Component({
  selector: 'app-billingproviders',
  templateUrl: './billingproviders.component.html',
  styleUrls: ['./billingproviders.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})

export class BillingprovidersComponent implements OnInit {
  columnsToDisplay = ['lastName', 'npiNumber', 'tinNumber', 'taxonomy', 'claimTypeName', 'activeStatus'];
  headercolumnsToDisplay = ['Last Name(Or)Organization Name', 'NPI', 'Tax ID', 'Taxonomy', 'ClaimType', 'Active Status'];
  expandedElement: IUserDetails | null;
  providerDetails: IUserDetails;
  id: Guid;
  ccPayers: InsuranceCarriers[] = [];
  payerInfo: InsuranceCarriers;
  claimType: IAttributes[];
  userId: string;
  //dataSource:any;
  public userStatus: any;
  public providerAddress: IAddress;
  allBillingProviders: IUserDetails[];
  payerType: string;
  payers: IAttributes[];
  public result: any;
  // dataSource:any;
  displayedColumnss: string[] = ['insuranceName', 'action'];
  public lstPayerName: IInsuranceCarriers[];
  public colPayerNames: IInsuranceCarriers[] = [];
  public selctedPayer: IInsuranceCarriers;
  dataSource = new MatTableDataSource(this.colPayerNames);
  lstUserPayers: any[] = [];
  allBillingProviderDatasource: any;
  public show: boolean = false;


  showInfo() {
    this.resetForm();
    this.expandedElement = null;
    this.show = !this.show;
  }


  billingprovidersform: FormGroup;
  submitted = false;


  constructor(private userService: UserManagementService, private formBuilder: FormBuilder, private toastr: ToastrService
    , private crypto: AESAlgorithm, private shared: SharedService, public dialog: MatDialog) {
    this.billingDropDownBindings();
    this.getAllUsersInfo();
  }

  ngOnInit() {
    this.billingprovidersform = this.formBuilder.group({
      lastName: ['', Validators.required],
      npiNumber: ['',],
      tinNumber: ['',],
      taxonomy: ['',],
      email: ['',],
      claimType: ['',],
      address1: ['',],
      address2: ['',],
      city: ['',],
      state: ['',],
      postalCode: ['',],
      phone: ['',],
      defaultProvider: ['',],
      payer: ['',],
      postalCodeExt: ['',],
      isActive: ['',],
      insuranceCarrierId: ['',]
    });

    this.providerAddress = {
      address1: '',
      address2: '',
      address3: '',
      addressId: null,
      state: '',
      stateCode: '',
      city: '',
      postalCode: '',
      postalExCode: '',
      cellPhone: null,
      workPhone: null,
      homePhone: null,
      fax: null,
      emailId: null,
      createdBy: '',
      createdOn: null,
      secondaryaddress1: '',
      secondaryaddress2: '',
      secondaryaddress3: '',
      secondarystate: '',
      secondarystateCode: '',
      secondarycity: '',
      secondarypostalCode: '',
      secondarypostalExCode: '',
      MailingAddress: '',
      phonenumber4: '',
      phonenumber5: ''
    }


  }

  billingDropDownBindings() {
    this.shared.getAttributesById(Defaults.claimMasterId).subscribe(data => {
      this.claimType = data;
    })

    this.shared.getInsCarriers().subscribe(data => {
      this.lstPayerName = data;
    });

  }

  get f() { return this.billingprovidersform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.billingprovidersform.invalid) {
      return;
    }

    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.billingprovidersform.value))
  }

  addProvider() {
    this.userId = this.billingprovidersform.value.lastName + this.billingprovidersform.value.claimType;
    this.providerDetails = this.billingprovidersform.value;
    this.providerDetails.roleName = '548C0389-5D0A-4B67-BD96-17270C4D9BAF';
    this.providerDetails.providerType = Defaults.providerType_Billing;
    this.providerDetails.facilityId = Number(sessionStorage.getItem("FacilityId"));;
    this.providerDetails.firstName = this.billingprovidersform.value.lastName;
    this.providerDetails.userId = this.crypto.encryptor(this.userId).toString();
    this.id = Guid.create();
    this.providerDetails.salt = this.id.toString().substring(0, 32);
    this.providerDetails.userPassword = this.crypto.encryptPassword(this.billingprovidersform.value.lastName, this.id.toString().substring(0, 32)).toString();

    // if(this.colPayerNames.length > 0){
    //   this.colPayerNames.forEach(element => {
    //     if (element.payerId != null) {
    //       var payerId = element.payerId;
    //       this.lstUserPayers.push(element.payerId);
    //     }
    //   });
    // }

    this.providerDetails.usercarriers = this.colPayerNames;

    this.userService.addUserInfo(this.providerDetails).subscribe(data => {
      this.toastr.success(data);
      this.getAllUsersInfo();
    })
    this.show = false;
  }


  onKeyPress(event: any) {
    const zip = event.target.value;
    if (zip.length == 5)
      this.getZipCodeInfo(zip);
    else {
      this.billingprovidersform.patchValue({
        city: '',
        state: ''
      });
    }
  }

  getZipCodeInfo(id: number) {
    this.shared.getZipCodeDetails(id)
      .subscribe(
        (city: ICityDetails) => {
          this.billingprovidersform.patchValue({
            city: city[0].cityName,
            state: city[0].stateName
          });
        },
        (err: any) => console.log(err)
      );
  }

  getAllUsersInfo() {
    this.userService.getAllBillingProviderPayers().subscribe(data => {
      this.allBillingProviders = data;
      // this.allBillingProviders = this.allBillingProviders.filter(x => x.providerType == 'Billing')

      this.allBillingProviderDatasource = new MatTableDataSource<IUserDetails>(this.allBillingProviders);
      // this.allBillingProviderDatasource.paginator = this.paginator;
    });
  }

  onCellClick(element: IUserDetails) {
    this.show = false;
    this.userId = this.crypto.encryptor(element.userId);
    this.billingprovidersform.patchValue({
      lastName: element.lastName,
      npiNumber: element.npiNumber,
      taxonomy: element.taxonomy,
      tinNumber: element.tinNumber,
      claimType: element.claimType,
      emailId: element.email,
      address1: element.address1,
      address2: element.address2,
      state: element.state,
      city: element.city,
      postalCode: element.postalCode,
      postalCodeExt: element.postalCodeExt,
      phone: element.phone,
      defaultProvider: element.defaultProvider,
      isActive: element.isActive
    });
    this.colPayerNames = element.usercarriers;
    this.dataSource.data = this.colPayerNames;

  }

  updateProvider(element: IUserDetails) {
    this.userId = this.crypto.encryptor(element.userId);
    this.providerDetails = this.billingprovidersform.value;
    this.providerDetails.roleName = '548C0389-5D0A-4B67-BD96-17270C4D9BAF';
    this.providerDetails.providerType = Defaults.providerType_Billing;
    this.providerDetails.facilityId = Number(sessionStorage.getItem("FacilityId"));;
    this.providerDetails.firstName = this.billingprovidersform.value.lastName;
    this.providerDetails.userId = this.userId.toString();
    this.id = Guid.create();
    this.providerDetails.salt = this.id.toString().substring(0, 32);
    this.providerDetails.userPassword = this.crypto.encryptPassword(this.billingprovidersform.value.lastName, this.id.toString().substring(0, 32)).toString();
    this.providerAddress.addressId = element.addressId;
    this.providerAddress.address1 = this.billingprovidersform.value.address1;
    this.providerAddress.address2 = this.billingprovidersform.value.address2;
    this.providerAddress.state = this.billingprovidersform.value.state;
    this.providerAddress.city = this.billingprovidersform.value.city;
    this.providerAddress.postalCode = this.billingprovidersform.value.postalCode;
    this.providerAddress.postalExCode = this.billingprovidersform.value.postalCodeExt;
    this.providerAddress.homePhone = this.billingprovidersform.value.phone;
    //this.providerAddress.fax = this.billingprovidersform.value.fax;
    this.providerAddress.workPhone = this.billingprovidersform.value.phone;
    this.providerAddress.cellPhone = this.billingprovidersform.value.phone;
    this.providerAddress.emailId = this.billingprovidersform.value.email;
    this.providerDetails.userAddressDetails = this.providerAddress;
    this.providerDetails.usercarriers = this.colPayerNames;
    this.userService.updateBillingProviderPayersInfo(this.providerDetails).subscribe(
      data => {
        this.toastr.success(data);
        this.getAllUsersInfo();
      }
    );

  }

  resetForm() {
    this.userId = null;
    this.colPayerNames = [];
    this.dataSource.data = this.colPayerNames;
    this.billingprovidersform.reset();
  }

  Search() {
    this.payerType = this.billingprovidersform.value.claimType;
    if (this.payerType != undefined && this.payerType != null && this.userId != "") {
      this.payers = this.claimType.filter(x => x.attributeId == this.payerType);
      this.payerType = this.payers[0].attributeName;
      const dialogRef = this.dialog.open(ProfessionalPayerComponent, {
        width: '600px',
        data: this.payerType
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          if (this.payerType == Defaults.claimType_Professional) {
            // this.payerInfo = new InsuranceCarriers();
            // this.payerInfo = result.payer;
            //this.payerInfo.insuranceName = result.insName;
            // this.ccPayers.push(result.payer);
            // this.dataSource = new MatTableDataSource<InsuranceCarriers>(this.ccPayers);
            //this.dataSource = this.ccPayers;
          }
          else if (this.payerType == Defaults.claimType_Institutional) {
            this.ccPayers.push(result.payer);
            // this.ActivePayersForm.patchValue({
            //   institutionPayer: result.insName
            // })
            // this.institutionalId = result.insId;
          }
        }
      });

    }
    else {
      this.toastr.warning("Please select Claim Type");
    }
  }

  AddPayerNames() {

    //  alert("category clicked" + this.billingprovidersform.value.insuranceCarrierId);

    if (this.billingprovidersform.value.insuranceCarrierId != undefined) {

      if (this.colPayerNames == null) {
        this.colPayerNames = [];
      }

      var elemt = this.lstPayerName.filter((attr: IInsuranceCarriers) => attr.insuranceCarrierId === this.billingprovidersform.value.insuranceCarrierId);
      this.selctedPayer = elemt[0];

      if (this.selctedPayer != null) {
        const removeindex = this.colPayerNames.findIndex(x => x.insuranceCarrierId === this.selctedPayer.insuranceCarrierId);
        if (removeindex == -1)
          this.colPayerNames.push(this.selctedPayer);
      }
      this.selctedPayer = null;

      this.dataSource.data = this.colPayerNames;
    }

  }

  OnCellDeletePayerInfo(element: IInsuranceCarriers) {
    //  alert("category clicked" + categoryCodeId);
    const message = "Are you sure to delete Payer? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      // maxWidth: '400px',
      width: '250px',
      height: '130px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {

        const removeindex = this.colPayerNames.findIndex(x => x.insuranceCarrierId === element.insuranceCarrierId);
        if (removeindex != -1)
          this.colPayerNames.splice(removeindex, 1);


        if (this.userId != null) {

          this.userService.DeleteBillingProviderPayerInfo(element.insuranceCarrierId, this.userId).subscribe(
            results => {
              this.result = results;
              // this.loadDxFormIcddata();
              this.toastr.success(this.result);
            }
          );
        }
        else {
          this.toastr.success("Payer details delete successfully");
        }

        this.dataSource.data = this.colPayerNames;

      } else {
        this.result = dialogResult;
      }
    });

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.allBillingProviderDatasource.filter = filterValue;
  }
}


